import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

const styles = {
  spinner: {
    marginRight: '5px',
  }
};

const SubmitButton = ({ block, bsSize, bsStyle, disabled, onClick, submitText, submitting, text, type }) => (
  <Button
    block={block}
    bsSize={bsSize}
    bsStyle={bsStyle}
    disabled={disabled || submitting}
    onClick={onClick}
    type={type}
  >
    {submitting ? (
      <FontAwesome
        name="spinner"
        spin
        style={styles.spinner}
      />
    ) : null}
    {`${(submitting && submitText) ? submitText : text}`}
  </Button>
);

SubmitButton.propTypes = {
  block: PropTypes.bool,
  bsSize: PropTypes.string,
  bsStyle: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  submitText: PropTypes.string,
  submitting: PropTypes.bool,
  text: PropTypes.string,
  type: PropTypes.string
};

SubmitButton.defaultProps = {
  block: false,
  bsSize: null,
  bsStyle: 'success',
  disabled: false,
  onClick: null,
  submitText: '',
  submitting: false,
  text: '',
  type: 'submit'
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/SubmitButton/index.js